<script>
import WelcomeDialog from '@components/dialogs/welcome-dialog.vue'
import { authComputed, authMethods } from '@state/helpers'
import PersonalMessage from '@components/personal-message/personal-message.vue'
import CommingSoonPopup from '@components/comming-soon-popup.vue'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import Cards from '@components/card/card-component.vue'
import { cardData } from '@components/card/card-data'
import VitalsCards from '@components/card/vitals-card-component.vue'
import DeviceCards from '@components/card/device-card-component.vue'
import { vitalsCardData } from '@components/card/vitals-card-data'
import settingsDialog from '@components/dialogs/settings-dialog.vue'
import AlertDialog from '@components/alert-dialog.vue'
import MessageAlert from '@components/message-alert.vue'
import DeviceDialog from '@components/dialogs/safehaven/device-dialog.vue'
import { connectDeviceService } from '@services/safehaven/ConnectDeviceService'
import { PulseLoader } from '@saeris/vue-spinners'
import store from '@state/store'
import axios from 'axios'
import { operationalService } from '@/src/services/safehaven/OperationService'

export default {
  page: {
    title: 'Index',
    meta: [{ name: 'description', content: 'The health help page.' }],
  },
  components: {
    PersonalMessage,
    WelcomeDialog,
    Cards,
    VitalsCards,
    DeviceCards,
    settingsDialog,
    CommingSoonPopup,
    AlertDialog,
    PulseLoader,
    DeviceDialog,
    MessageAlert,
  },
  mixins: [layout, NavigateMixin],
  props: {},
  data() {
    return {
      isloading: false,
      cardData,
      isShowAlert: false,
      alertTitle: 'You are now leaving this website',
      alertMesasge:
        ' You are being redirected to an external site. Would you like to proceed?',
      explore: 'Explore HealthBook+',
      displayPersonalMessage: true,
      clicked: false,
      connected: null,
      commingSoonPopup: false,
      validicSupportURL: '',
      messages: [
        {
          id: '1',
          title: 'How are you feeling today?',
          felling: [
            {
              status: 'Bad',
              icon: require('@assets/images/safehaven/Emoticon-Bad.svg'),
              Isicon: true,
            },
            {
              status: 'Just OK',
              icon: require('@assets/images/safehaven/Emoticon-JustOK.svg'),
              Isicon: true,
            },
            {
              status: 'Great!',
              icon: require('@assets/images/safehaven/Emoticon-Great.svg'),
              Isicon: true,
            },
          ],
        },
      ],
      dialog: false,
      vitalCards: [],
      vitalCardsBase: [],
      hide: true,
      userData: null,
      loadingBiometricData: false,
      biometricError: null,
      validicData: null,
      validicUserId: null,
      deviceType: null,
      showNoData: false,
      connectedDeviceName: null,
      showSwitch: false,
      DEVICES: {
        garmin: 'Garmin Connect',
        fitbit: 'Fitbit',
        apple_health: 'Apple Health',
        google_fit_sdk: 'Google Fit',
      },
      connectedDeviceList: [],
      isShowDeviceListAlert: false,
      isShowMessageAlert: false,
      mesasgeText: 'Use the app on your mobile device to disconnect',
      validicDeviceList: [],
      isShowDeviceList: false,
    }
  },

  computed: {
    ...authComputed,

    dialogComputed: {
      get() {
        return !this.settings?.welcomed
      },
      set(newValue) {
        this.dialog = newValue
      },
    },
  },
  async mounted() {
    this.userData = this.$store.state.auth.currentUser
    this.validicSupportURL =
      this.$store.state.auth.currentUser.user.validic_supported_device
    if (this.userData && this.userData.user.answer_saved) {
      this.hide = true
    }
    if (this.userData && this.userData.user.validic_user.sources) {
      this.validicUserId = this.userData.user.validic_user.uid
      if (this.userData.user.validic_user.sources.length > 0) {
        this.deviceType = this.userData.user.validic_user.sources[0].type
      }
    }
    if (
      this.userData &&
      (!this.userData.user.settings.welcomed || !this.userData.user.settings)
    ) {
      this.vitalCards = []
    }
    if (
      this.userData &&
      (this.userData.user.validic_user_status === 'Synced' ||
        this.userData.user.validic_user_status === 'Connected')
    ) {
      this.connectedDeviceName = this.userData.user.validic_user.sources[0].type
      this.connectedDeviceList = this.userData.user.validic_user.sources

      if (this.userData.user.validic_user.sources.length > 1) {
        this.connectedDeviceList = this.userData.user.validic_user.sources
        this.showSwitch = true
      }
      this.loadingBiometricData = true
      this.getBiometricData()
      if (
        this.cardData.length > 0 &&
        this.userData.user.validic_user_status === 'Synced'
      ) {
        this.cardData[0].title = 'Connect/Disconnect a Device'
      }
    }
    this.connected = this.userData.user.validic_user_status
  },
  created() {
    this.firstTimeUser()
    this.getValidicUserMarketplaceDevices()
  },
  methods: {
    ...authMethods,
    async firstTimeUser() {
      if (await this.settings.answer_saved) {
        this.hide = true
      }
    },
    getSupportedDevicePDF() {
      axios.get('/api/v1/me/').then((response) => {
        this.validicSupportURL = response.data.validic_supported_device
      })
    },
    async getValidicUserMarketplaceDevices() {
      const response =
        await connectDeviceService.getValidicUserMarketplaceDevices()
      this.validicDeviceList = response
    },
    async connectDevice() {
      try {
        if (
          this.connectedDeviceName === 'apple_health' ||
          this.connectedDeviceName === 'google_fit_sdk'
        ) {
          this.isShowMessageAlert = true
        } else {
          const getLink = (await connectDeviceService.connectDevice()).data
          if (getLink) {
            window.open(getLink.marketplace_url, '_blank')
            this.connected = getLink.validic_user_status
            store.dispatch('auth/fetchUser')
          }
        }
      } catch (error) {
        console.warn(error.response)
      }
    },
    async getBiometricData() {
      try {
        const validicResponse =
          await connectDeviceService.getValidicWearableData(
            this.validicUserId,
            this.deviceType
          )
        this.validicData = validicResponse.data
        console.warn(validicResponse.data)
        this.parseBiometricData()
      } catch (error) {
        this.biometricError =
          'There was an error getting your health data. Please try reloading the page.'
        console.warn('Biometric data error: ', error)
      }
    },

    async saveOperation(card) {
      try {
        var req = {
          organization_id: this.userData.user.user_org_details[0].org,
          feature_id: card.id,
        }
        await operationalService.saveOperation(req).then((res) => {})
      } catch (error) {
        console.warn(error)
      }
    },

    startChat() {
      this.$router.push({ name: 'safehaven-peer-coaching' })
    },
    shedule() {
      this.$router.push({ name: 'safehaven-telehealth' })
    },
    showAlert() {
      this.isShowAlert = true
    },
    hideAlert() {
      this.isShowAlert = false
    },
    showDeviceAlert() {
      this.isShowDeviceListAlert = true
    },
    hideDeviceAlert() {
      this.isShowDeviceListAlert = false
    },
    hideMessageAlert() {
      this.isShowMessageAlert = false
    },
    handleSuccess(selectedDevice) {
      this.isShowAlert = false
      window.open('https://www.youtube.com/channel/UCjuVY7k9HsY4Ebj1D0dL0SA')
    },
    handleDeviceSuccess(selectedDevice) {},
    getSettings(settingsObj) {
      if (this.settings.welcomed) {
        this.vitalCards = this.vitalCards.filter((cardData, index) => {
          return cardData.status
        })

        this.vitalCards = this.vitalCardsBase.map((cardData, index) => {
          settingsObj.vitals_status.map((card) => {
            if (card.vital_name === cardData.title) {
              cardData.status = card.status
            }
          })
          return cardData
        })

        this.vitalCards = this.vitalCards.filter((cardData, index) => {
          return cardData.status
        })
      } else {
        this.vitalCards = []
      }
    },
    openCloseCommingSoon() {
      this.commingSoonPopup = !this.commingSoonPopup
    },

    parseBiometricData() {
      let biometricData = JSON.parse(JSON.stringify(vitalsCardData))
      if (Object.keys(this.validicData).length === 0) {
        this.showNoData = true
      } else {
        for (const key in this.validicData) {
          biometricData.map((bioItem) => {
            if (bioItem.key === key) {
              bioItem.status = true
            }
          })
        }

        biometricData = biometricData.map((item) => {
          switch (item.key) {
            case 'heart_rate_details':
              if (
                this.validicData &&
                Object.keys(this.validicData).length !== 0 &&
                this.validicData[item.key] &&
                Object.keys(this.validicData[item.key]).length !== 0
              ) {
                item.minReading = this.validicData[item.key].min_heart_rate
                  ? Math.trunc(
                      this.validicData[item.key].min_heart_rate
                    ).toString()
                  : ''
                item.maxReading = this.validicData[item.key].max_heart_rate
                  ? Math.trunc(
                      this.validicData[item.key].max_heart_rate
                    ).toString()
                  : ''
                item.currentReading = this.validicData[item.key].avg_heart_rate
                  ? Math.trunc(
                      this.validicData[item.key].avg_heart_rate
                    ).toString()
                  : '-- '
              } else {
                item.minReading = ''
                item.maxReading = ''
                item.currentReading = ''
                item.resultText = ''
                item.weeklyAvg = ''
                item.status = false
              }
              break
            case 'spo2_details':
              if (
                this.validicData &&
                Object.keys(this.validicData).length !== 0 &&
                this.validicData[item.key] &&
                Object.keys(this.validicData[item.key]).length !== 0
              ) {
                item.minReading = this.validicData[item.key].min_spo2
                  ? this.validicData[item.key].min_spo2.toString()
                  : ''
                item.maxReading = this.validicData[item.key].max_spo2
                  ? this.validicData[item.key].max_spo2.toString()
                  : ''
                item.currentReading = this.validicData[item.key].avg_spo2
                  ? this.validicData[item.key].avg_spo2.toString()
                  : '-- '
              } else {
                item.minReading = ''
                item.maxReading = ''
                item.currentReading = ''
                item.resultText = ''
                item.weeklyAvg = ''
                item.status = false
              }
              break
            case 'sleep':
              if (
                this.validicData &&
                Object.keys(this.validicData).length !== 0 &&
                this.validicData[item.key] &&
                Object.keys(this.validicData[item.key]).length !== 0
              ) {
                item.currentReading = this.validicData[item.key].today
                  ? this.validicData[item.key].today
                  : '0:0'
              } else {
                item.minReading = ''
                item.maxReading = ''
                item.currentReading = ''
                item.resultText = ''
                item.weeklyAvg = ''
                item.status = false
              }
              break
            case 'steps_details':
              if (
                this.validicData &&
                Object.keys(this.validicData).length !== 0 &&
                this.validicData[item.key] &&
                Object.keys(this.validicData[item.key]).length !== 0
              ) {
                item.currentReading = this.validicData[item.key].today
                  ? this.getLocaleString(
                      this.validicData[item.key].today
                    ).toString()
                  : '0'
              } else {
                item.minReading = ''
                item.maxReading = ''
                item.currentReading = ''
                item.resultText = ''
                item.weeklyAvg = ''
                item.status = false
              }
              break

            case 'distance_details':
              if (
                this.validicData &&
                this.validicData[item.key] &&
                Object.keys(this.validicData).length !== 0 &&
                Object.keys(this.validicData[item.key]).length !== 0
              ) {
                item.currentReading = this.validicData[item.key].today
                  ? this.validicData[item.key].today.toString()
                  : '0'
              } else {
                item.minReading = ''
                item.maxReading = ''
                item.currentReading = ''
                item.resultText = ''
                item.weeklyAvg = ''
                item.status = false
              }
              break
            default:
              break
          }
          this.vitalCardsBase = this.vitalCards = biometricData
        })
        this.vitalCards = this.vitalCards.filter((cardData, index) => {
          return cardData.status
        })
        localStorage.setItem('validicData', JSON.stringify(this.vitalCards))
      }
      this.loadingBiometricData = false
    },
    getTimeInHours(secondsValue) {
      secondsValue = parseInt(secondsValue)
      const timeInHr = secondsValue / 3600
      const hrPart = Math.trunc(timeInHr)
      const minPart = Math.round((timeInHr % 1) * 100)
      return hrPart + ':' + minPart
    },
    getLocaleString(value) {
      return Math.trunc(value).toLocaleString('en-US')
    },
    getMilesFromMeter(value) {
      return (value / 1609).toFixed(2)
    },
    openNewIsabelSymptomChecker() {
      window.open(
        'https://symptomchecker.isabelhealthcare.com/index.jsp?passcode=CJK0Xj6NCaVeDIp6tpK3op7Q4Yl5Kv2S'
      )
    },
    showAvailableDevices() {
      this.isShowDeviceList = true
    },
  },
}
</script>

<template>
  <div v-if="userData" :class="[$style.dashboardContainer]">
    <WelcomeDialog
      v-if="
        (userData &&
          userData.user.settings &&
          !userData.user.settings.welcomed) ||
        !userData.user.settings
      "
      :value.sync="dialogComputed"
      :org-id="userData.user.user_org_details[0].org"
    ></WelcomeDialog>
    <CommingSoonPopup
      :dialog="commingSoonPopup"
      @close-dialog="openCloseCommingSoon"
    ></CommingSoonPopup>
    <AlertDialog
      :show-alert="isShowAlert"
      :alert-title="alertTitle"
      :alert-message="alertMesasge"
      @success="handleSuccess"
      @close-alert="hideAlert"
    ></AlertDialog>
    <DeviceDialog
      :show-alert="isShowDeviceListAlert"
      :connected-device-list="connectedDeviceList"
      @success="handleDeviceSuccess"
      @close-alert="hideDeviceAlert"
    ></DeviceDialog>
    <MessageAlert
      :show-alert="isShowMessageAlert"
      :alert-message="mesasgeText"
      @close-alert="hideMessageAlert"
    ></MessageAlert>
    <v-row v-if="!$store.state.personalMessages.personalMessage" class="mt-0">
      <v-col class="pa-0">
        <PersonalMessage
          v-for="message in messages"
          :id="message.id"
          :key="message.id"
          :title="message.title"
          :felling="message.felling"
        ></PersonalMessage>
      </v-col>
    </v-row>
    <div class="mt-5 pt-5 mx-5">
      <v-container
        v-if="!hide"
        fluid
        :class="[$style.containerCard, 'pa-7 mt-6']"
      >
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex align-center">
              <v-img
                width="32"
                height="32"
                contain
                :src="
                  require('@assets/images/safehaven/dashboard/Personal.svg')
                "
                class="flex-grow-0 mr-2"
              ></v-img>
              <h1 :class="[$style.title, 'ma-0']"> Own Your Health </h1>
            </div>
            <p :class="[$style.desc, 'my-5']">
              Ready to start improving your life? HealthBook+ gives you the
              ability to own, control and manage your family’s health care and
              wellness.
            </p>
            <v-btn
              class="primary-btn"
              :class="$style.btnClass"
              @click="navigateToScreen('profile-questionnaire')"
            >
              My Lifestyle & Goals
            </v-btn>
          </div>
          <div v-if="!$vuetify.breakpoint.xs">
            <v-img
              width="200"
              contain
              :src="
                require('@assets/images/safehaven/dashboard/DashboardHero.svg')
              "
              class="ml-16"
            ></v-img>
          </div>
        </div>
      </v-container>
      <v-container fluid :class="[$style.containerCard, 'pa-7 mt-6']">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-img
                  width="32"
                  height="32"
                  contain
                  :src="
                    require('@assets/images/safehaven/dashboard/Biometric.svg')
                  "
                  class="flex-grow-0 mr-2"
                ></v-img>
                <h1 :class="[$style.title, 'ma-0']"> Health Biometrics </h1>
              </div>
              <div v-if="vitalCards.length > 0">
                <settingsDialog @settings-saved="getSettings"></settingsDialog>
              </div>
            </div>
            <p :class="[$style.desc, 'my-5']">
              Integrate your smart watch, fitness tracker or health app to track
              and analyze your health so we can recommend your next best health
              action.
            </p>
            <v-btn
              class="primary-btn mb-5"
              :class="$style.btnClass"
              @click="navigateToScreen('connection-hub')"
            >
              Go to Connection Hub
            </v-btn>
            <!-- <v-btn
              v-if="
                !isShowDeviceList &&
                connected !== 'Synced' &&
                connected !== 'Connected'
              "
              class="primary-btn mb-5"
              :class="$style.btnClass"
              @click="showAvailableDevices"
            >
              Connect a device or app
            </v-btn> -->
          </div>
          <div
            v-if="
              $vuetify.breakpoint.mdAndUp &&
              !isShowDeviceList &&
              connected !== 'Synced' &&
              connected !== 'Connected'
            "
          >
            <v-img
              width="200"
              contain
              :src="
                require('@assets/images/safehaven/dashboard/Smartwatch.svg')
              "
              class="ml-16"
            ></v-img>
          </div>
        </div>
        <div v-if="isShowDeviceList">
          <v-row align="center" justify="center">
            <DeviceCards
              v-for="device in validicDeviceList"
              :key="device.type"
              :type="device.type"
              :connected="device.connected"
              :displayname="device.display_name"
              :tagline="device.tag_line"
              :logourl="device.logo_url"
              :actionurl="
                device.connected ? device.disconnect_url : device.connect_url
              "
            />
          </v-row>
        </div>
        <div v-if="connected === 'Synced' || connected === 'Connected'">
          <div class="d-flex mb-3">
            <img
              :src="require('@assets/images/safehaven/check_black.png')"
              width="20"
              height="20"
              class="mr-1"
            />
            <p :class="[$style.connectedDeviceText, 'mb-0']">
              Device(s) connected:
              <a @click="connectDevice">
                <span :class="$style.connectedDeviceNameStyleBold">
                  {{ DEVICES[connectedDeviceName] || connectedDeviceName }}
                </span>
              </a>
              <a v-if="showSwitch" @click="showDeviceAlert">
                <span :class="$style.connectedDeviceNameStyle"> (Switch) </span>
              </a>
              <span :class="$style.connectedDesc"
                >(Use mobile app to connect/disconnect from
                {{ DEVICES[connectedDeviceName] || connectedDeviceName }})</span
              >
            </p>
          </div>
          <!-- <div class="pl-0">
            <p>
              Connect your wearable devices so we can analyze your health and
              recommend your next best health action.
              <a :href="validicSupportURL" target="_blank">
                Check supported devices
              </a>
            </p>
          </div> -->
          <div v-if="loadingBiometricData" :class="$style.loaderContainer">
            <PulseLoader color="#7EB3E7" :size="20" />
            <span :class="$style.loaderText"> Loading Biometric Data </span>
          </div>
          <div v-if="biometricError" :class="$style.loaderContainer">
            <span :class="$style.errorText"> {{ biometricError }} </span>
          </div>
          <v-row v-if="!loadingBiometricData && !biometricError" no-gutters>
            <VitalsCards
              v-for="card in vitalCards"
              :key="card.id"
              :img="card.src"
              :title="card.title"
              :unit-long="card.unitLong"
              :unit-short="card.unitShort"
              :current-reading="card.currentReading"
              :min-reading="card.minReading"
              :max-reading="card.maxReading"
              :rem-reading="card.remReading"
              :awake-reading="card.awakeReading"
              :current-text="card.currentText"
              :min-text="card.minText"
              :max-text="card.maxText"
              :rem-text="card.remText"
              :awake-text="card.awakeText"
              :result-text="card.resultText"
              :status="card.status"
              :show-details="card.showDetails"
            ></VitalsCards>
          </v-row>
          <div v-if="showNoData" :class="$style.noDataAlert">
            <v-icon
              v-if="!notDesktop"
              :class="[$style.cardImg, 'mr-2']"
              color="#0476d9"
            >
              mdi-alert-circle-outline
            </v-icon>
            <p :class="[$style.noDataAlertText, 'ma-0 flex-grow-1']">
              Now that you've connected your smart device please sync your
              device one time with your fitness/health provider. And refresh
              this page.
            </p>
          </div>
          <v-row v-if="showNoData">
            <v-col cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
              <div :class="$style.cardOuter">
                <v-card :class="$style.cardStyle" outlined>
                  <div :class="$style.noDataImg">
                    <v-img
                      height="132"
                      width="173"
                      class="mt-12"
                      contain
                      :src="
                        require('@assets/images/safehaven/dashboard/no-data.png')
                      "
                    ></v-img>
                    <p :class="$style.resultText">No Data Available</p>
                  </div>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>

      <v-container fluid class="mt-6 pa-0">
        <v-row no-gutters>
          <v-card
            v-if="isloading"
            width="100%"
            color="offwhite"
            outlined
            rounded="lg"
            loading
            class="px-0"
          >
            <template slot="progress">
              <v-progress-linear
                v-if="isloading"
                color="primary"
                indeterminate
              ></v-progress-linear>
              <div v-else :class="$style.loaderPlaceholder"></div>
            </template>
          </v-card>
          <Cards
            v-for="card in cardData"
            :key="card.key"
            :carddata="card"
            @document-center="navigateToScreen('safehaven-health-vault')"
            @symptom-checker="openNewIsabelSymptomChecker"
            @add-record="saveOperation(card)"
          ></Cards>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.logo {
  width: auto;
  height: 305px;
  padding: 5px;
}

.mandatory {
  margin-top: 16px;
  font-size: 20px !important;
  color: #da1414;
}

.clickHere {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.headerContainerMobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.headerContainerDesktop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
}

.header {
  font-size: 28px;
  font-weight: 400;
  line-height: 38px;
  color: #000;
  letter-spacing: -0.30000001192092896px;
}

.subHeader {
  margin-left: 2px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000;
  text-align: left;
  letter-spacing: 0;
}

.profileBtn {
  height: 46px !important;
  margin-top: 22px;
  font-size: 18px !important;
  font-weight: 600;
  line-height: 27px;
  color: #fff !important;
  text-align: center;
  text-transform: capitalize;
  letter-spacing: 0;
  background-color: #0476d9 !important;
  border-radius: 32px;
}

.containerCard {
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}

.syncSize {
  width: 50%;
  margin-top: 16px;
  font-size: 20px !important;
  line-height: 2rem;
  color: #1f6ad7;
}

.cardIcons {
  width: 63px;
  height: 50px;
}

.vCardContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
}

.vCardTitle {
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.dashboardContainer {
  width: 100%;
  background: #f2f9ff;
}

.title {
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.desc {
  font-size: 14px;
  line-height: 21px;
  text-align: left;
}

.buttonWrapp {
  display: flex;
  align-items: center;
}
.buttonDisplay {
  display: flex;
  align-items: center;
}
.buttonClass {
  margin: 2px;
  color: #0476d9 !important;
  text-transform: capitalize;
}

.buttonClass:first-child,
.buttonClass:hover {
  color: white !important;
  background-color: #0476d9;
}
.connectedDeviceText {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.connectedDeviceNameStyleBold {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: #0476d9;
}
.connectedDeviceNameStyle {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #0476d9;
}
.connectedDesc {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}
.cardStyle {
  min-height: 250px;
  text-align: center;
  border-radius: 9px !important;
  box-shadow: 0 0 6px rgba(146, 191, 231, 0.6);
}
.cardStyle p {
  margin-bottom: 0 !important;
}

.cardOuter {
  padding: 20px 0;
}

.noDataImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 132px;
}
.resultText {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #000;
  text-align: center !important;
  letter-spacing: 0;
}
.noDataAlert {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-right: 10px;
  border-radius: 5px;
}
.cardImg {
  width: 15px !important;
}
.noDataAlertText {
  font-size: 14px;
  color: #000;
}

.exploreclss {
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.3px;
}

.loaderContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loaderText {
  margin-top: 15px;
  font-size: 15px;
  color: #0476d9;
}

.errorText {
  font-size: 18px;
  color: #0476d9;
}
.deviceLink {
  margin-left: 15px;
  font-size: 1rem;
}
.btnClass {
  width: 230px;
}

@media screen and (max-width: 1861px) {
  .cardStyle p {
    min-height: 120px;
  }
}

@media screen and (max-width: 959px) {
  .cardStyle {
    padding: 50px !important;
  }

  .cardStyle p {
    min-height: inherit;
  }
  .syncSize {
    width: 100%;
  }
}

@media screen and (max-width: 479px) {
  .cardOuter {
    padding: 10px 0;
  }

  .cardStyle {
    padding: 30px !important;
  }
}

@media screen and (max-width: 960px) {
  .buttonClass {
    margin: 0;
  }
  .buttonClass:hover {
    color: white !important;
    background-color: #0476d9;
  }
}

@media screen and (max-width: 600px) {
  .btnClass {
    width: 100%;
  }
}
@media screen and (max-width: 460px) {
  .deviceLink {
    display: block;
    margin-left: 0;
  }
  .buttonWrapp {
    flex-wrap: wrap;
  }
}
</style>
